export const TOPIC = "/topic";
export const TOPIC_FEED = TOPIC + "/feed";
export const TOPIC_FEED_ADD = TOPIC_FEED + "/add";
export const TOPIC_FEED_VOTE = TOPIC_FEED + "/vote";
export const TOPIC_PING_VOTE = TOPIC + "/ping";
export const TOPIC_FEED_SCHEDULE = TOPIC_FEED + "/schedule";
export const TOPIC_CHAT = (myProfileId: string) => `${TOPIC}/chat/${myProfileId}`;
export const TOPIC_NOTIFICATIONS = (myProfileId: string) => `${TOPIC}/notifications/${myProfileId}`;
export const TOPIC_MENTIONS = (myProfileId: string) => `${TOPIC}/mentions/${myProfileId}`;
export const TOPIC_TWEET = (tweetId: number | string) => `${TOPIC}/tweet/${tweetId}`;
export const TOPIC_TWEET_VOTE = (tweetId: number | string) => `${TOPIC}/tweet/vote/${tweetId}`;
export const TOPIC_USER_ADD_TWEET = (userId: number | string) => `${TOPIC}/user/add/tweet/${userId}`;
export const TOPIC_USER_VOTE_TWEET = (userId: number | string) => `${TOPIC}/user/vote/tweet/${userId}`;
export const TOPIC_USER_UPDATE_TWEET = `${TOPIC}/user/update/tweet`;
export const TOPIC_DELETE_TWEET = `${TOPIC}/tweet/delete`;
export const TOPIC_DELETE_REPLY_TWEET = `${TOPIC}/tweet/reply/delete`;
export const TOPIC_TOP_CHAT_USER_SND = (userId: string) => `${TOPIC}/chat/sender/${userId}`;
export const TOPIC_TOP_CHAT_USER_RCV = (userId: string) => `${TOPIC}/chat/reciever/${userId}`;
export const TOPIC_REJECT_TWEET = `${TOPIC}/tweet/reject`;
export const TOPIC_USER_UPDATE = (userId: string) => `${TOPIC}/user/update/${userId}`;

